import '@onestep/coreui/tokens.css';
import '@onestep/coreui/style.css';
import './styles/compiled_tailwind.scss';
import './styles/compiled_multiplatform.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '@sendbird/uikit-react/dist/index.css';
import 'react-phone-input-2/lib/style.css';
import './index.module.scss';
import 'core-js/actual/array/to-sorted';

import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { CamelApiProvider } from '@onestep/camel-api/hooks';
import { SurfaceProvider } from '@onestep/coreui/surface';
import { QueryClientProvider } from '@tanstack/react-query';
import { configure } from 'mobx';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { ToastContainer } from 'react-toastify';

import { camelClient } from '@/services/camelClient';
import { installStaleChunkRecovery } from '@/services/staleChunkRecovery';

import AppRouter from './AppRouter';
import theme from './assets/theme';
import { FeatureFlagProvider } from './components/FeatureFlagProvider';
import IntercomProvider from './components/IntercomProvider';
import { queryClient } from './config/query-client';
import i18n from './i18n';
import { DEFAULT_NS } from './i18n/types';
import { getPortalRuntimeConfig } from './services/runtimeConfig';

installStaleChunkRecovery();

configure({ isolateGlobalState: true });

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

const { posthog } = getPortalRuntimeConfig();

root.render(
  <React.StrictMode>
    <SurfaceProvider surface="web">
      <FeatureFlagProvider
        config={{
          apiKey: posthog.key ?? '',
          options: {
            api_host: posthog.host,
          },
        }}
      >
        <IntercomProvider>
          <I18nextProvider i18n={i18n} defaultNS={DEFAULT_NS}>
            <QueryClientProvider client={queryClient}>
              <CamelApiProvider client={camelClient}>
                <DndProvider backend={HTML5Backend}>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                      <AppRouter />
                    </ThemeProvider>
                  </StyledEngineProvider>
                  <ToastContainer
                    toastClassName="!p-0 !bg-transparent !shadow-none w-fit"
                    bodyClassName="!p-0"
                  />
                </DndProvider>
              </CamelApiProvider>
            </QueryClientProvider>
          </I18nextProvider>
        </IntercomProvider>
      </FeatureFlagProvider>
    </SurfaceProvider>
  </React.StrictMode>,
);
